import { SITE } from "../lib/site";
import { Instagram, Facebook } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/10 bg-[#040404]"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3">
              <img
                src={SITE.media.logo}
                alt="Shine and Drive Car Cleaning"
                className="h-16 w-16 object-contain"
              />
              <span className="font-display text-2xl tracking-wide">
                Shine <span className="text-gold italic">&amp;</span> Drive
              </span>
            </div>
            <p className="mt-5 text-white/55 max-w-sm leading-relaxed">
              Premium hand-detailing run by two North Seattle students.
              Treating every car like our own.
            </p>

            <div className="mt-7 flex items-center gap-3">
              <a
                href={SITE.socials.instagram.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                aria-label="Instagram"
                className="h-11 w-11 grid place-items-center border border-white/15 rounded-full text-white/80 hover:border-gold hover:text-gold transition-colors"
              >
                <Instagram size={16} />
              </a>
              <a
                href={SITE.socials.facebook.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-facebook"
                aria-label="Facebook"
                className="h-11 w-11 grid place-items-center border border-white/15 rounded-full text-white/80 hover:border-gold hover:text-gold transition-colors"
              >
                <Facebook size={16} />
              </a>
              <span className="ml-2 text-xs uppercase tracking-[0.22em] text-white/45">
                {SITE.socials.instagram.handle}
              </span>
            </div>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.28em] text-white/45 mb-4">
              Visit
            </div>
            <ul className="space-y-3 text-white/75">
              <li>{SITE.area}</li>
              <li>{SITE.hours}</li>
            </ul>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.28em] text-white/45 mb-4">
              Connect
            </div>
            <ul className="space-y-3 text-white/75">
              <li>
                <a
                  href={`mailto:${SITE.email}`}
                  data-testid="footer-email"
                  className="hover:text-gold transition-colors break-all"
                >
                  {SITE.email}
                </a>
              </li>
              <li>
                <a
                  href={`tel:+1${SITE.phoneRaw}`}
                  data-testid="footer-phone"
                  className="hover:text-gold transition-colors"
                >
                  {SITE.phone}
                </a>
              </li>
              <li>
                <a
                  href={SITE.bookingUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-book"
                  className="hover:text-gold transition-colors"
                >
                  Book Online ↗
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-white/40">
          <div>
            © {new Date().getFullYear()} Shine and Drive Car Cleaning. All
            rights reserved.
          </div>
          <div className="uppercase tracking-[0.28em]">
            Hand-built in Seattle
          </div>
        </div>
      </div>
    </footer>
  );
}
